import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSearchNationalitiesQuery } from '@massilia/queries';
import { AutoComplete, useDebounce } from '@massilia/ui';
import { useStore } from '@tanstack/react-form';
import { Globe } from 'lucide-react';
import { useMemo, useState } from 'react';
import { useFieldContext } from '../hooks/use-app-form.js';
import { DEFAULT_OPTION } from '../schemas/estimate/base-schemas.js';
import { FieldDisplayValue } from './field-display-value.js';
import { FieldError } from './field-error.js';
export function NationalityAutocompleteField({ autoFocus, label, onDisplayClick, renderType = 'edit', }) {
    const [searchText, setSearchText] = useState('');
    const debouncedSearchText = useDebounce(searchText, 200);
    const { data, isLoading } = useSearchNationalitiesQuery({
        search: debouncedSearchText,
    });
    const options = useMemo(() => {
        if (!data?.nationalities)
            return [];
        return data.nationalities.map((n) => ({
            label: n.nationalityFr,
            value: n.alpha3Code,
        }));
    }, [data]);
    const field = useFieldContext();
    const errors = useStore(field.store, (state) => state.meta.errors);
    const selectedOption = useMemo(() => {
        const currentValue = field.state.value?.value;
        if (!currentValue)
            return;
        // First try to find in provided options
        const foundOption = options.find((opt) => opt.value === currentValue);
        if (foundOption)
            return foundOption;
        // Fallback to the provided option if it has a label (initial value case)
        if (field.state.value?.label) {
            return field.state.value;
        }
        return;
    }, [options, field.state.value]);
    if (renderType === 'display') {
        return (_jsx(FieldDisplayValue, { label: label, onClick: onDisplayClick, value: field.state.value?.label ?? '' }));
    }
    return (_jsxs("div", { className: "relative flex flex-col gap-2", children: [label && _jsx("label", { className: "text-sm font-medium", children: label }), _jsx(AutoComplete, { autoFocus: autoFocus, emptyMessage: "Aucune nationalit\u00E9 trouv\u00E9e", icon: _jsx(Globe, { className: "h-4 w-4 text-gray-light-700" }), isLoading: isLoading, onBlurCallBack: () => {
                    field.handleBlur();
                }, onInputChange: (text) => {
                    setSearchText(text);
                }, onValueChange: (opt) => {
                    if (opt) {
                        field.handleChange(opt);
                    }
                    else {
                        field.handleChange(DEFAULT_OPTION);
                    }
                }, options: options, placeholder: "Nationalit\u00E9", shouldFilter: false, value: selectedOption }), _jsx(FieldError, { errors: errors })] }));
}
